import { toast } from 'react-toastify';
import { removeFromDraft } from '../common/checks_Func'
import { MdDelete } from "react-icons/md";

function Drafts({data, pick, updateDraftData}) {

  const previousDrafts = data?.data || []

  function deleteFromDraftsCollection(ID){
    removeFromDraft(ID)
    toast.success("Removed from drafts")
    updateDraftData()
  }


  

  return (
    <div className='bg-[#101010] relative pb-5 rounded-md'>

    <p className='w-full bg-[#101010] p-4 text-xl font-bold'>Drafts</p>

    <div className='px-4 py-8 h-[100vh] overflow-y-scroll no-scrollbar'>
        {previousDrafts.length > 0 ? previousDrafts.toReversed().map((item,index) => {
            return (
            <div 
            onClick={() => {
              pick(item?.id)
            }}
            key={index}
            className='cursor-pointer relative flex justify-center 
            items-center h-[200px] bg-[#7E6E6E] my-5 rounded-xl'>

          <div 
            onClick={(e) => {
              e.stopPropagation()
              deleteFromDraftsCollection(item?.id)
            }}
            className='cursor-pointer absolute top-2 right-2 z-[2] p-2.5'>
            <MdDelete
             className='text-2xl' />
            </div>

                <h4 className='font-bold text-xl'>{item?.topic}</h4>
            </div>
            )
        })
        :
        <div className='flex justify-center'>
          <p>Empty</p>
        </div>
        }

    </div>
    </div>
  )
}

export default Drafts